import { Loader2 } from 'lucide-react';
import { OpportunityCtaButtonProps } from '../pages/AdvisorDashboardOpportunities';
import { Button } from './ui/button';

interface OpportunityFloatingActionMenuProps {
  selectedCount?: number;
  onSendReminder?: () => void;
  floatingMenuCtaProps: OpportunityCtaButtonProps;
}

export function OpportunityFloatingActionMenu({
  selectedCount = 0,
  floatingMenuCtaProps,
}: OpportunityFloatingActionMenuProps) {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 z-50 w-full sm:bottom-8 sm:left-1/2 sm:mx-0 sm:w-[500px] sm:-translate-x-1/2">
      <div className="flex items-center justify-between gap-4 bg-primary-dark px-4 py-4 text-white shadow-lg sm:rounded-2xl sm:py-2">
        {/* selected count */}
        <div className="hidden items-center justify-center gap-2 sm:flex">
          <div className="hidden h-8 min-w-8 items-center justify-center rounded-full bg-accent px-2 text-sm font-bold text-white sm:flex">
            {selectedCount}
          </div>
          <span className="text-sm text-white">Selected</span>
        </div>
        {/* buttons */}
        <div className="flex items-center gap-2">
          <Button
            disabled={floatingMenuCtaProps.disabled}
            className="flex items-center gap-2 rounded-lg bg-primary px-3 py-1.5 text-sm transition-colors hover:bg-primary-hover disabled:opacity-50"
            onClick={floatingMenuCtaProps.onClick}
          >
            {floatingMenuCtaProps.loading ? (
              <Loader2 className="animate-spin" />
            ) : (
              floatingMenuCtaProps.icon
            )}
            <span>{floatingMenuCtaProps.text}</span>
          </Button>
        </div>
      </div>
    </div>
  );
}
